exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formik-label {\n  font-weight: 500; }\n", ""]);

// exports
